import { Component, OnInit, ViewChild } from '@angular/core';
import { Platform, ModalController, IonInfiniteScroll } from '@ionic/angular';
import { HttpCustomerService, MessageclientService, NativeService } from 'src/service';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from 'src/service/common.service';
import { BaseCase } from 'src/app/basecase';
import { BaseModal } from 'src/model';
import { GridBaseCase } from '../../../grid/grid.base.case';
import { WebParameterContext } from 'src/model/common';
import { SearchModalPage } from "../search-modal/search-modal.page";
declare var app;
@Component({
  selector: 'app-content-library-home',
  templateUrl: './content-library-home.component.html',
  styleUrls: ['./content-library-home.component.scss']
})
export class ContentLibraryHomeComponent extends GridBaseCase {
  tabsIndex: any = 0;
  remarkvalue: any; //信息反馈字段
  outOrInType: string;//调出或者调入类型type
  outOrInName: string;
  pageName: string = null;
  searchValue: any = "";
  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
  RecordCount: Number = 0;//列表总数量
  addobject: any = {};//多选
  dataArrayList: Array<any> = [];//数据列表
  dataArrayListtop: Array<any> = [];//置顶的数据
  btnInfo: any = [
    { type: 1, name: "内容分类", icon: "/assets/img/A2/a2-icon28.png" },
    { type: 2, name: "孕育小工具", icon: "/assets/img/A2/a2-icon29.png" },
    { type: 3, name: "我的收藏  ", icon: "/assets/img/A2/a2-icon30.png" },
    { type: 4, name: "浏览历史", icon: "/assets/img/A2/a2-icon31.png" },
  ];
  hotSearchInfo1: any = [
    { type: 1, name: "孕期护理" },
    { type: 2, name: "孕期护理" },
    { type: 3, name: "孕期护理" },
  ];//孕期热搜数据源
  hotSearchInfo2: any = [
    { type: 1, name: "孕期护理" },
    { type: 2, name: "孕期护理" },
    { type: 3, name: "孕期护理" },
  ];//宝期热搜数据源
  isShowSearchModel: boolean = false;
  initLoadData: boolean = true;
  isLoadAllData: boolean = false;//数据是否加载完成
  clickLoadMoreData: boolean = false;//点击加载更多数据
  articleListData = [];//文章列表数据源
  isFirstLoad:boolean = true;
  constructor(
    private platform: Platform,
    private http: HttpCustomerService,
    private activaRouter: ActivatedRoute,
    private router: Router,
    private msg: MessageclientService,
    private com: CommonService,
    private native: NativeService,
    public baseService: BaseCase,
    public base: BaseModal,
    public modal: ModalController,
  ) {
    super();
    this.LoadData(1);
    this.LoadDattop(1);
  }


  /**
   * 
   * @param e 跳转页面
   */
  EvrntDetail(item, i) {
    const that = this;
    that.com.setHistoryUrl(true);
    that.com.Go("/tabs/contact/ContentLibraryDetail/" + this.com.getNowDatetime,{
      a_ID: item.a_ID,
      type: 4 // 1 代表点击搜索列表跳详情 2 代表我的收藏列表跳详情， 3代表浏览历史列表跳详情页 4代表首页的
    })
  }
  ngOnInit() {
  }
  loadMoreData(event) {
    let that = this;
    // const len = that.articleListData.length + that.dataArrayListtop.length;
    const len = that.articleListData.length;
    if (that.RecordCount == len) {
      that.isLoadAllData = true;
      // else if (that.RecordCount == (that.dataArrayList.length + that.dataArrayListtop.length))
    } else if (that.RecordCount == that.dataArrayList.length) {
      
      that.clickLoadMoreData = true;
      that.articleListData = [];
      that.dataArrayList.forEach(item => {
        that.articleListData.push(item);
      });
      that.clickLoadMoreData = false;
      that.isLoadAllData = true;
    } else {
      that.PageNumber++;
      this.LoadData(that.PageNumber);
      that.clickLoadMoreData = true;
    }


    // if (that.RecordCount == that.baseService.arrayData.length) {
    //   if (that.infiniteScroll) {
    //     that.infiniteScroll.disabled = true;
    //   }

    // } else {
    //   that.PageNumber++;
    //   this.LoadData(that.PageNumber);
    // }
  }

  LoadData(PageNumber) {
    var that = this;
    that.PageNumber = PageNumber;
    if (PageNumber == 1) {
      that.loading = false;
      that.apiObj['status'] = false;
      that.apiObj['msg'] = '';
    }
    
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
    body.Account = that.com.GetAccount;
    body.ConfigName = "V_TBArticleContentXML";
    body.OpType = "query";
    body.ConfigType = "view";
    body.QueryOrderBy = [
      {
        "OrderByColumnName": "a_type",
        "OrderByType": "desc"
      },
      {
        "OrderByColumnName": "a_ArticleTime",
        "OrderByType": "desc"
      }
    ];
    body.RowsPerPage = 10;
    body.PageNumber = PageNumber;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 2;
    let typeObj = {};
    typeObj["a_type"]= 1;
    typeObj["a_IsPlacedTop"]= false;
    body.RequestBody = JSON.stringify(typeObj);
    that.http.post(app.DEFAULTURL, body).then(data => {
      console.log(data ,"所有数据所有数据");
      that.isFirstLoad = false;
      /****判断是否第一页begin****/
      that.clickLoadMoreData = false;
      if (PageNumber == 1) {
        that.initLoadData = true;
        that.articleListData = [];
        that.dataArrayList = [];
        // that.dataArrayListtop= [];
        that.apiObj['status'] = data.ResponseMessage.Success;
        that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
        that.loading = true;
      }
      /****判断是否第一页end****/
      if (data.ResponseMessage.Success) {
        // that.dataArrayListtop= [];
        if(PageNumber == 1){
          that.initLoadData = true;
          that.articleListData = [];
          that.dataArrayList = [];
          // that.dataArrayListtop= [];
          // debugger;
          data.Status.Datas.forEach(item => {
              if(item.a_type == 1){
                // if (item.a_IsPlacedTop) {
                //   if(item.a_ModifyTime){
                //     item.a_ModifyTime= item.a_ModifyTime.replace(/-/g,"/").replace("T","");
                //   }
                //   that.dataArrayListtop.push(item);
                // } else {
                  if(item.a_ModifyTime){
                    item.a_ModifyTime= item.a_ModifyTime.replace(/-/g,"/").replace("T","");
                  }
                  if(item.a_ArticleTime){
                    item.a_ArticleTime= item.a_ArticleTime.replace(/-/g,"/").replace("T","");
                  }
                  that.articleListData.push(item);
                  that.dataArrayList.push(item);
                // }
              }
           
          })
        }else{
          data.Status.Datas.forEach(function (item) {
            if(item.a_ModifyTime){
              item.a_ModifyTime= item.a_ModifyTime.replace(/-/g,"/").replace("T","");
            }
            if(item.a_ArticleTime){
              item.a_ArticleTime= item.a_ArticleTime.replace(/-/g,"/").replace("T","");
            }
            that.dataArrayList.push(item);
            
          });
          if(that.dataArrayList.length > (PageNumber*10-5)){
            that.dataArrayList.slice((PageNumber*10-15),(PageNumber*10-5)).forEach(item=>{
              that.articleListData.push(item);
              if (item.a_IsPlacedTop) {
                that.dataArrayListtop.push(item);
              }
            })
          }else if(that.dataArrayList.length < 15){
            that.articleListData = [];
            that.dataArrayList.forEach(item=>{
              that.articleListData.push(item);
              if (item.a_IsPlacedTop) {
                that.dataArrayListtop.push(item);
              }
            })
          }else{
            that.dataArrayList.slice((PageNumber*10-15)).forEach(item=>{
              that.articleListData.push(item);
              if (item.a_IsPlacedTop) {
                that.dataArrayListtop.push(item);
              }
            })
          }
        }
        if(that.initLoadData){
          that.initLoadData = false;
          that.articleListData.length > 5?that.articleListData.splice(5):false;
        }

        
        /****上拉加载数据begin****/
        
        // let len = that.articleListData.length + that.dataArrayListtop.length;
        let len = that.articleListData.length;
        that.RecordCount = data.Status.RecordCount;
        if (that.RecordCount==len) {
          // that.infiniteScroll.disabled = true;
          that.isLoadAllData = true;
        } else {
          that.isLoadAllData = false;
        }
        /****上拉加载数据end****/
      }else{
        that.isFirstLoad = false;
        that.isLoadAllData=false;
      }

    }).catch(error => {
      that.isFirstLoad = false;
      that.isLoadAllData=false;
      that.apiObj['status'] = false;
      that.apiObj['msg'] = error.ResponseMessage.ErrorMessage;
      that.loading = true;
      // console.log(error);
    });
  }




  // 置顶数据
  LoadDattop(PageNumber) {
    var that = this;
    that.PageNumber = PageNumber;
    
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
    body.Account = that.com.GetAccount;
    body.ConfigName = "V_TBArticleContentXML";
    body.OpType = "query";
    body.ConfigType = "view";
    body.QueryOrderBy = [
      {
        "OrderByColumnName": "a_type",
        "OrderByType": "desc"
      },
      {
        "OrderByColumnName": "a_ArticleTime",
        "OrderByType": "desc"
      }
    ];
    body.RowsPerPage = 10;
    body.PageNumber = PageNumber;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 2;
    let typeObj = {};
    typeObj["a_type"]= 1;
    typeObj["a_IsPlacedTop"]= true;
    body.RequestBody = JSON.stringify(typeObj);
    that.http.post(app.DEFAULTURL, body).then(data => {
      console.log(data ,"所有数据所有数据");
      that.isFirstLoad = false;
      /****判断是否第一页begin****/
      that.clickLoadMoreData = false;
      if (PageNumber == 1) {
        that.dataArrayListtop= [];
        that.apiObj['status'] = data.ResponseMessage.Success;
        that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
        that.loading = true;
      }
      /****判断是否第一页end****/
      if (data.ResponseMessage.Success) {
        // that.dataArrayListtop= [];
        data.Status.Datas.forEach(item => {
            if(item.a_ModifyTime){
              item.a_ModifyTime= item.a_ModifyTime.replace(/-/g,"/").replace("T","");
            }
            if(item.a_ArticleTime){
              item.a_ArticleTime= item.a_ArticleTime.replace(/-/g,"/").replace("T","");
            }
            that.dataArrayListtop.push(item);
       
      })
        // console.log( data.Status.Datas.data,"数据");
        // that.dataArrayListtop=data.Status.Datas;

        
        /****上拉加载数据begin****/
        
       
      }else{
        // that.isFirstLoad = false;
        // that.isLoadAllData=false;
        that.msg.Alert(data.ResponseMessage.ErrorMessage);
      }

    }).catch(error => {
      // that.isFirstLoad = false;
      // that.isLoadAllData=false;
      that.apiObj['status'] = false;
      that.apiObj['msg'] = error.ResponseMessage.ErrorMessage;
      that.loading = true;
      // console.log(error);
    });
  }

  searchEvent(e, type: string = 'type') {

    const that = this;
    // if (!that.searchValue) {
    //   that.msg.Alert("物流单号不能为空哦！");
    //   return;
    // }
    if (e.keyCode == 13 || type == 'search') {
      that.LoadData(1);
    }
  }

  async openSearchModel() {
    // this.isShowSearchModel = true;
    // this.com.setHistoryUrl();
    const modal = await this.modal.create({
      component: SearchModalPage,
      componentProps: {
        "Type": "Home",
      }
    });
    await modal.present();
    const { data } = await modal.onWillDismiss();
  }
  // 标签跳转
  classifiCation(it,id,num) {
    const that = this;
    // this.router.navigate(["/tabs/contact/ContentLibraryDetails/" + this.com.getNowDatetime], {
    //   queryParams: {
    //     nodeLevel:nodeLevel,
    //     fiCationID: id, //分类标签id
    //   }
    // });
    let a_cID:any ="";
    let a_dID:any ="";
    let a_eID:any ="";
    switch(num){
      case 1:
        a_cID= id;
        break;
      case 2:
        a_dID = id;
        break;
      case 3:
        a_eID= id;
        break;
    }
    this.com.setHistoryUrl();
    this.com.Go("/tabs/contact/ContentLibraryList/" + this.com.getNowDatetime,{
      searchValue:it,
        nodeLevel:num,
        a_cID:a_cID,
        a_dID:a_dID,
        a_eID:a_eID,
        type:8 // 1 代表点击搜索列表跳详情 2 代表我的收藏列表跳详情， 3代表浏览历史列表跳详情页
    });
    // this.router.navigate(["/tabs/contact/ContentLibraryList/" + this.com.getNowDatetime], {
    //   queryParams: {
    //     searchValue:it,
    //     nodeLevel:num,
    //     a_cID:a_cID,
    //     a_dID:a_dID,
    //     a_eID:a_eID,
    //     type:8 // 1 代表点击搜索列表跳详情 2 代表我的收藏列表跳详情， 3代表浏览历史列表跳详情页
    //   }
    // });
  }

  goDetailPage(item) {
    const that = this;
    switch (item.type) {
      case 1://内容分类
        that.com.setHistoryUrl(true);
        that.com.Go("/tabs/contact/ContentLibraryDetails/" + that.com.getNowDatetime,{
          type: 1 // 1 代表点击搜索列表跳详情 2 代表我的收藏列表跳详情， 3代表浏览历史列表跳详情页
        });
        
        break;
      case 2://小工具
        that.com.setHistoryUrl();
        that.com.Go("/tabs/contact/NestmomGroup/view/" + that.com.getNowDatetime);
        break;
      case 3://我的收藏
        that.com.setHistoryUrl();
        that.com.Go("/tabs/contact/ContentLibraryList/sc/" + that.com.getNowDatetime,{
          type: 2 // 1 代表点击搜索列表跳详情 2 代表我的收藏列表跳详情， 3代表浏览历史列表跳详情页
        });
        break;
      case 4://浏览历史
        that.com.setHistoryUrl();
        that.com.Go("/tabs/contact/ContentLibraryList/history/" + that.com.getNowDatetime,{
          type: 3 // 1 代表点击搜索列表跳详情 2 代表我的收藏列表跳详情， 3代表浏览历史列表跳详情页
        });
        break;
    }

  }

}
